import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Chip,
  Grid2,
  IconButton,
  Typography,
} from "@mui/material";
import PrimaryIcon from "Components/Common/PrimaryIcon";
import React, { useMemo, useState } from "react";
import { ReactComponent as ExpandIcon } from "Assets/Icons/Leaderboard/ExpandIcon.svg";
import { ReactComponent as CollapseIcon } from "Assets/Icons/Leaderboard/CollapseIcon.svg";
import { useSelector } from "react-redux";


const styles = (theme) => ({
  display: "flex",
  flexDirection: "column",
  gap: "15px",
});

const NewUpdates = () => {
  const [expanded, setExpanded] = useState([]);

  const { Translation } = useSelector((state) => ({
    Translation: state.Translation.translation?.LeaderBoard || {},
  }));

  const handleChange = (value) => (e, newExpanded) => {
    if (newExpanded) {
      setExpanded((pre) => [...pre, value]);
    } else {
      setExpanded((pre) => pre?.filter((item) => item != value));
    }
  };

  const updates = useMemo(() => {
    return [
      {
        question: Translation?.WhatReputationPoints,
        answer: [
          {
            type: "subtitle",
            value: Translation?.ReputationPointSolvingAssignment,
          },
          {
            type: "ol",
            value: [
              Translation?.HintsAccessedProcess,
              Translation?.TestCasesCleared,
            ],
          },
          {
            type: "desc",
            value: Translation?.ProblemSolvingEfficient,
          },
          {
            type: "subtitle",
            value: Translation?.ShowCaseProgress
          },
        ],
      },
      {
        question: Translation?.HowMyRankCalculated,
        answer: Translation?.RankSorted,
      },
      {
        question: Translation?.SomePeopleReputationPoints,
        answer: Translation?.PossibleHigherReputationPoints
      },
    ];
  }, [Translation]) 


  return (
    <Grid2 sx={styles}>
      {updates?.map((item, i) => {
        const isOpen = expanded.includes(i + 1);
        return (
          <Accordion
            elevation={0}
            bordered
            expanded={isOpen}
            onChange={handleChange(i + 1)}
          >
            <AccordionSummary
              expandIcon={
                <IconButton filled>
                  {" "}
                  <PrimaryIcon
                    color="white"
                    icon={isOpen ? CollapseIcon : ExpandIcon}
                    width="16px"
                    height="16px"
                  />{" "}
                </IconButton>
              }
            >
              {i == 0 && (
                <Chip
                  sx={(theme) => ({
                    backgroundColor: theme.palette.yellow.main,
                    position: "absolute",
                    left: "16px",
                    top: "-12px",
                  })}
                  size="small"
                  label={<Typography fontWeight={500}> {Translation?.NewUpdate} </Typography>}
                />
              )}
              <Typography fontWeight={500} variant="subtitle">
                {item?.question}
              </Typography>{" "}
            </AccordionSummary>
            <AccordionDetails primary>
              <Typography>
                {typeof item?.answer == "string"
                  ? item?.answer
                  : item?.answer?.map((ans, i) => {
                      return ans?.type == "desc" ? (
                        ans?.value
                      ) : ans?.type == "subtitle" ? (
                        <Typography fontWeight={500}> {ans?.value} </Typography>
                      ) : (
                        <ol>
                          {ans?.value?.map((li, i) => {
                            return <li key={`li${i}`}> {li} </li>;
                          })}
                        </ol>
                      );
                    })}
              </Typography>
            </AccordionDetails>
          </Accordion>
        );
      })}
    </Grid2>
  );
};

export default NewUpdates;
